import { PropertyDevelopmentType } from './PropertyDevelopmentType';

export const PropertyDevelopmentTypeOptions = [
    {
        id: PropertyDevelopmentType.NewConstruction,
        name: 'New Construction',
        shortName: 'New Construction',
        sortOrder: 1,
        active: true,
    },
    {
        id: PropertyDevelopmentType.Renovation,
        name: 'Recent Renovation',
        shortName: 'Recent Renovation',
        sortOrder: 2,
        active: true,
    },
    {
        id: PropertyDevelopmentType.RenovationAndExpansion,
        name: 'Recent Renovation and Expansion',
        shortName: 'Recent Renovation and Expansion',
        sortOrder: 3,
        active: true,
    },
    {
        id: PropertyDevelopmentType.NewAcquisition,
        name: 'New Acquisition',
        shortName: 'New Acquisition',
        sortOrder: 4,
        active: true,
    },
    {
        id: PropertyDevelopmentType.Other,
        name: 'Other',
        shortName: 'Other',
        sortOrder: 5,
        active: true,
    },
];
